import React, { useState, useEffect, useRef } from 'react'

const placeHolder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII='

interface Props {
  src: string
  alt: string
  width: number
  height: number
}

export const LazyImage: React.FC<Props> = ({ src, alt, width, height }) => {
  const [imageSrc, setImageSrc] = useState(placeHolder)
  const imageRef = useRef<HTMLImageElement | null>(null)

  const onLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.classList.add('loaded')
  }

  const onError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.classList.add('has-error')
  }

  useEffect(() => {
    let observer: IntersectionObserver
    let didCancel = false
    const image = imageRef.current

    if (image && imageSrc !== src) {
      if (IntersectionObserver) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (
                !didCancel &&
                (entry.intersectionRatio > 0 || entry.isIntersecting)
              ) {
                setImageSrc(src)
                if (imageRef && image) {
                  observer.unobserve(image)
                }
              }
            })
          },
          {
            threshold: 0.01,
            rootMargin: '75%',
          }
        )
        observer.observe(image)
      } else {
        // Old browsers fallback
        setImageSrc(src)
      }
    }
    return () => {
      didCancel = true
      // on component cleanup, we remove the listner
      if (observer && observer.unobserve && image) {
        observer.unobserve(image)
      }
    }
  }, [src, imageSrc, imageRef])

  return (
    <img
      ref={imageRef}
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      onLoad={onLoad}
      onError={onError}
    />
  )
}
